// Dependencias
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Componentes
import BannerFichas from '../../../components/BannerFichas/BannerFichas';
import Navbar from '../../../components/Navbar/Navbar';
import SessionBar from '../../../components/SessionBar/SessionBar';
import Footer from '../../../components/Footer/Footer';
import CardListaJuego from '../../../components/CardListaJuego/CardListaJuego';

// Funciones
import { ROUTES } from '../../../const/routes';
import { fetchUserData } from '../../../utils/api';
import { useTranslation } from 'react-i18next';

const ListaJuegos = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    fetchUserData(navigate, setUserData);
  }, [navigate]);

  const irAJuego = (nombreJuego) => {
    navigate(ROUTES.juegos + '/' + nombreJuego);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <BannerFichas />
      <div className="bg-gradient-to-b from-slate-950 to-violet-950 flex-grow">
        <Navbar />
        <SessionBar />

        <div className="flex flex-col items-center justify-center text-center py-4 md:py-6 px-4">
          <h2 className="text-xl md:text-2xl text-yellow-500 font-bold mb-2.5">
            {t('gamesList.title')}
          </h2>
          <p className="text-xs md:text-sm text-gray-300 mb-5">
            {t('gamesList.subtitle')}
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5 w-full max-w-5xl">
            <CardListaJuego
              imagen={ROUTES.rutaPortadasJuegos + 'Ruleta01Resized.png'}
              valor={t('gamesList.roulette')}
              funcion={() => irAJuego('ruleta')}
            />
            <CardListaJuego
              imagen={ROUTES.rutaPortadasJuegos + 'Tragamonedas01Resized.png'}
              valor={t('gamesList.slots')}
              funcion={() => irAJuego('tragamonedas')}
            />
            <CardListaJuego
              imagen={ROUTES.rutaPortadasJuegos + 'BlackJack01Resized.png'}
              valor={t('gamesList.blackjack')}
              funcion={() => irAJuego('blackJack')}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ListaJuegos;
